import {
	Button,
	Card,
	Carousel,
	Cascader,
	Col,
	Form,
	Image,
	Input,
	InputNumber,
	Row,
	Timeline,
	message,
	Tooltip
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { injectIntl } from 'react-intl'
import { Link, useHistory } from 'react-router-dom'
import LoadingBar from 'react-top-loading-bar'

//import MCarousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

import Auxiliary from 'util/Auxiliary'
import IntlMessages from 'util/IntlMessages'
import BannerService from './../../../services/Banner'
import ProductService from './../../../services/Product'
import UserProductService from './../../../services/UserProduct'

const phoneRegex = new RegExp(/(^(\+88)?(01){1}[3456789]{1}(\d){8})$/)
// eslint-disable-next-line no-useless-escape
const emailRegex = new RegExp(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/)
const phoneOrEmailRegex = new RegExp(
	phoneRegex.source + '|' + emailRegex.source
)

// const cardResponsiveness = {
// 	desktop: {
// 		breakpoint: { max: 3000, min: 1024 },
// 		items: 3,
// 		slidesToSlide: 1
// 	},
// 	tablet: {
// 		breakpoint: { max: 1024, min: 728 },
// 		items: 2,
// 		slidesToSlide: 1
// 	},
// 	mobile: {
// 		breakpoint: { max: 728, min: 0 },
// 		items: 1,
// 		slidesToSlide: 1
// 	}
// }

const Home = ({ intl }) => {
	const loadingRef = useRef(null)
	const [loading, setLoading] = useState(true)
	const [form] = Form.useForm()
	const history = useHistory()
	const [products, setProducts] = useState([])
	const [carouselProducts, setCarouselProducts] = useState([])
	const [productList, setProductList] = useState([])
	const [gateways, setGateways] = useState([])
	const [idRequired, setIdRequired] = useState(false)
	const [amountDisabled, setAmountDisabled] = useState(false)
	const [currentNews, setCurrentNews] = useState([])
	const language = JSON.parse(localStorage.getItem('language'))

	const user = JSON.parse(localStorage.getItem('user'))
	if (user && !form.getFieldsValue().phoneOrEmail) {
		form.setFieldsValue({ phoneOrEmail: user.id })
	}

	useEffect(() => {
		loadingRef.current.continuousStart()
		// product fetching
		ProductService.getAll().then(
			res => {
				loadingRef.current.complete()
				if (res.state === 'success') {
					setLoading(false)
					localStorage.setItem('products', JSON.stringify(res.products))
					var tempProducts = res.products
					// console.log(res.products)
					var startingProducts = []
					var startingProductsCar = []
					const zakatProduct = tempProducts.find(
						item => item.name === 'donation.product.zakat.title'
					)
					const complexProduct = tempProducts.find(
						item => item.name === 'donation.product.complex.title'
					)
					const skillProduct = tempProducts.find(
						item =>
							item.name === 'donation.product.skill-development-institute.title'
					)
					const generalProduct = tempProducts.find(
						item => item.name === 'donation.product.general.title'
					)
					const donorMembership = tempProducts.find(
						item => item.name === 'donation.product.membership.donor.title'
					)
					const lifetimeMembership = tempProducts.find(
						item => item.name === 'donation.product.membership.lifetime.title'
					)
					if (lifetimeMembership) {
						res.products.splice(res.products.indexOf(lifetimeMembership), 1)
					}
					if (donorMembership) {
						res.products.splice(res.products.indexOf(donorMembership), 1)
					}
					if (complexProduct) {
						startingProducts.push(complexProduct)
						startingProductsCar.push(complexProduct)
						res.products.splice(res.products.indexOf(complexProduct), 1)
					}
					if (skillProduct) {
						startingProducts.push(skillProduct)
						startingProductsCar.push(skillProduct)
						res.products.splice(res.products.indexOf(skillProduct), 1)
					}
					if (zakatProduct) {
						startingProducts.push(zakatProduct)
						startingProductsCar.push(zakatProduct)
						tempProducts.splice(tempProducts.indexOf(zakatProduct), 1)
					}
					if (generalProduct) {
						startingProducts.push(generalProduct)
						startingProductsCar.push(generalProduct)
						res.products.splice(res.products.indexOf(generalProduct), 1)
					}
					const monthlyProduct = tempProducts.find(
						item => item.name === 'donation.product.monthly.title'
					)
					if (monthlyProduct) {
						// startingProducts.push(monthlyProduct)
						startingProductsCar.push(monthlyProduct)
						tempProducts.splice(tempProducts.indexOf(monthlyProduct), 1)
					}
					// Exclude 'donation.product.qurbani.title'
					tempProducts = tempProducts.filter(
						item => item.name !== 'donation.product.qurbani.title'
					)

					setProducts([...startingProducts, ...tempProducts])
					setCarouselProducts([...startingProductsCar, ...tempProducts])
					setProductList(
						[...startingProducts, ...tempProducts].map(item => ({
							value: item._id,
							priority: item.priority,
							label: intl.formatMessage({ id: item.name })
						}))
					)
				} else {
					message.warning(intl.formatMessage({ id: res.message }))
				}
			},
			err => {
				loadingRef.current.complete()
				console.error(err)
				message.error(intl.formatMessage({ id: 'backend.network.error' }))
			}
		)
		// news fetching
		BannerService.getAvailable().then(
			res => {
				if (res.state === 'success') {
					// console.log(res.banners)
					setCurrentNews(res.banners)
				} else {
					message.warning(intl.formatMessage({ id: res.message }))
				}
			},
			err => {
				console.error(err)
				message.error(intl.formatMessage({ id: 'backend.network.error' }))
			}
		)

		setGateways([
			{
				value: 'bkash',
				label: intl.formatMessage({ id: 'gateway.label.bkash' })
			},
			{
				value: 'others',
				label: intl.formatMessage({ id: 'gateway.label.others' })
			}
		])
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleDonationTypeChange = value => {
		const selectedProduct = products.find(item => item._id === value[0])
		setIdRequired(selectedProduct.amountIsFixed)
		setAmountDisabled(selectedProduct.amountIsFixed)

		const currentValues = form.getFieldsValue()
		if (
			selectedProduct.amountIsFixed &&
			currentValues.phoneOrEmail &&
			phoneOrEmailRegex.test(currentValues.phoneOrEmail)
		) {
			if (/(^(01){1}[3456789]{1}(\d){8})$/.test(currentValues.phoneOrEmail)) {
				currentValues.phoneOrEmail = '+88' + currentValues.phoneOrEmail
			}
			setLoading(true)
			loadingRef.current.continuousStart()
			ProductService.getAmount(
				selectedProduct._id,
				currentValues.phoneOrEmail
			).then(
				res => {
					setLoading(false)
					loadingRef.current.complete()
					if (res.state === 'success') {
						if (res.amount) {
							setAmountDisabled(true)
							form.setFieldsValue({
								paymentAmount: res.amount
							})
							message.success(
								`Your monthly payment amount is ${res.amount} BDT`
							)
						} else {
							setAmountDisabled(false)
							form.setFieldsValue({
								paymentAmount: 10
							})
						}
					} else {
						message.warning(intl.formatMessage({ id: res.message }))
					}
				},
				err => {
					setLoading(false)
					loadingRef.current.complete()
					console.error(err)
					message.error(intl.formatMessage({ id: 'backend.network.error' }))
				}
			)
		}
	}

	const handleFormValuesChanged = (changedValues, allValues) => {
		if (!loading) {
			var selectedProduct = undefined
			if (
				changedValues.phoneOrEmail &&
				allValues.donationType &&
				phoneOrEmailRegex.test(changedValues.phoneOrEmail)
			) {
				if (/(^(01){1}[3456789]{1}(\d){8})$/.test(changedValues.phoneOrEmail)) {
					changedValues.phoneOrEmail = '+88' + changedValues.phoneOrEmail
				}
				selectedProduct = products.find(
					item => item._id === allValues.donationType[0]
				)
				if (selectedProduct.amountIsFixed) {
					setLoading(true)
					loadingRef.current.continuousStart()
					ProductService.getAmount(
						selectedProduct._id,
						changedValues.phoneOrEmail
					).then(
						res => {
							setLoading(false)
							loadingRef.current.complete()
							if (res.state === 'success') {
								if (res.amount) {
									setAmountDisabled(true)
									form.setFieldsValue({
										paymentAmount: res.amount
									})
									message.success(
										`Your monthly payment amount is ${res.amount} BDT`
									)
								} else {
									setAmountDisabled(false)
									form.setFieldsValue({
										paymentAmount: 10
									})
								}
							} else {
								message.warning(intl.formatMessage({ id: res.message }))
							}
						},
						err => {
							setLoading(false)
							loadingRef.current.complete()
							console.error(err)
							message.error(intl.formatMessage({ id: 'backend.network.error' }))
						}
					)
				}
			}
		}
	}

	const onSubmit = values => {
		if (!loading) {
			if (/(^(01){1}[3456789]{1}(\d){8})$/.test(values.phoneOrEmail)) {
				values.phoneOrEmail = '+88' + values.phoneOrEmail
			}
			// let gateway = values.gateway[0] !== undefined ? values.gateway[0] : values.gateway
			setLoading(true)
			loadingRef.current.continuousStart()
			UserProductService.purchase(
				products.find(item => item._id === values.donationType[0])._id,
				values.paymentAmount,
				values.phoneOrEmail,
				null,
				null,
				null
				// gateway
			).then(
				res => {
					setLoading(false)
					loadingRef.current.complete()
					if (res.state === 'success') {
						window.location.href = res.paymentGatewayUrl
					} else {
						message.warning(intl.formatMessage({ id: res.message }))
					}
				},
				err => {
					setLoading(false)
					loadingRef.current.complete()
					console.error(err)
					message.error(intl.formatMessage({ id: 'backend.network.error' }))
				}
			)
		}
	}

	const QuickDonation = ({
		productList,
		gatewayList,
		idRequired,
		amountDisabled,
		containerStyle
	}) => (
		<Row className='gx-main-content-wrapper'>
			<Col xl={24}>
				<Card style={{ marginBottom: '0px' }}>
					<Form
						// layout='inline'
						form={form}
						name='quickdonate'
						size='large'
						onFinish={onSubmit}
						style={{
							flexWrap: 'nowrap',
							flexDirection: 'row',
							gap: '5px',
							justifyContent: 'space-between',
							marginTop: '9px',
							padding: '0 25px'
						}}
						scrollToFirstError
						onValuesChange={handleFormValuesChanged}
					>
						<Row
							gutter={50}
							style={{
								padding: 0
							}}
						>
							<Col xs={24} md={12} lg={5} style={{ paddingBottom: '0px' }}>
								<Form.Item
									style={{ flex: 1, paddingBottom: '0px' }}
									name='donationType'
									rules={[
										{
											required: true,
											message: intl.formatMessage({
												id: 'quick.donation.donationType.message'
											})
										}
									]}
								>
									<Cascader
										style={{ width: '100%' }}
										options={productList.sort(
											(a, b) => parseInt(a.priority) - parseInt(b.priority)
										)}
										onChange={handleDonationTypeChange}
										placeholder={intl.formatMessage({
											id: 'quick.donation.donationType.placeholder'
										})}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} md={12} lg={5} style={{ paddingBottom: '0px' }}>
								<Form.Item
									style={{ flex: 1, paddingBottom: '0px' }}
									name='phoneOrEmail'
									rules={[
										{
											required: true,
											pattern: phoneOrEmailRegex,
											message: intl.formatMessage({
												id: 'quick.donation.phoneOrEmail.message'
											}),
											whitespace: true
										}
									]}
								>
									<Input
										placeholder={intl.formatMessage({
											id: 'quick.donation.phoneOrEmail.placeholder'
										})}
										disabled={user && user.id}
										suffix={
											<Tooltip
												title={intl.formatMessage({
													id: 'payment.info.emailORphone.message'
												})}
											>
												<InfoCircleOutlined
													style={{
														color: 'rgba(0,0,0,.45)'
													}}
												/>
											</Tooltip>
										}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} md={12} lg={5} style={{ paddingBottom: '0px' }}>
								<Form.Item
									style={{ flex: 1, paddingBottom: '0px' }}
									name='paymentAmount'
									rules={[
										{
											required: true,
											message: intl.formatMessage({
												id: 'quick.donation.amount.message'
											})
										},
										{
											validator: (_, value) => {
												if (value < 10) {
													return Promise.reject(
														intl.formatMessage({
															id: 'payment.info.amount.errorMessage.10'
														})
													)
												}
												return Promise.resolve()
											}
										}
									]}
								>
									<InputNumber
										style={{ width: '100%' }}
										// min={10}
										max={9999999999999}
										disabled={amountDisabled}
										placeholder={intl.formatMessage({
											id: 'quick.donation.amount.placeholder'
										})}
										step={0.01}
										stringMode
										formatter={value =>
											value ? value.replace(/(\.\d{2})\d+$/, '$1') : ''
										}
										parser={value => value.replace(/[^0-9.]/g, '')}
									/>
								</Form.Item>
							</Col>
							{/* <Col lg={5} md={12} sm={24}>
                <Form.Item
                  style={{ flex: 1 }}
                  name='gateway'
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: 'quick.donation.gateway.message'
                      })
                    }
                  ]}
                >
                  <Cascader
                    options={gatewayList}
                    placeholder={intl.formatMessage({
                      id: 'quick.donation.gateway.placeholder'
                    })}
                  />
                </Form.Item>
              </Col> */}
							<Col lg={4} md={12} xs={24} style={{ paddingBottom: '0px' }}>
								<Form.Item style={{ paddingBottom: '0px' }}>
									<Button
										type='primary'
										size='large'
										htmlType='submit'
										className='gx-mb-0'
										style={{
											backgroundColor: '#EE0000',
											color: '#ffffff',
											width: '100%'
										}}
									>
										<IntlMessages id='payment.info.donateButton' />
									</Button>
								</Form.Item>
							</Col>
						</Row>
					</Form>
					<p
						style={{
							textAlign: 'center'
						}}
					>
						<IntlMessages id='national.board.order.messge.1' />
						<Link to='/sro'>
							<IntlMessages id='national.board.order.messge.2' />
						</Link>
					</p>
				</Card>
			</Col>
		</Row>
	)

	const videoData = [
		'wKV4pZrep6E',
		'6w4SCAnPxS8',
		'T4VIMchyz34',
		'8YMNH2zM1SE',
		'K2eXoxL-5og',
		'zx0TWzkd524',
		'm0SrsVcFykw',
		'B3pif_kyJoY',
		'pokrKG0d5Wc',
		'xnKpHk1ESkw',
		'T_qg3QFcmIc',
		'56cBlOKUkyc',
		'7vRDmjsd6xg'
	]

	// const OngoingProjects = [
	// 	// {
	// 	// 	id: 1,
	// 	// 	name: 'ongoing.project.name.qurbani.project.current.year',
	// 	// 	img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/qurbani_for_all_2024.jpg',
	// 	// 	description: 'ongoing.project.description.qurbani.project.current.year'
	// 	// },
	// 	{
	// 		id: 1,
	// 		name: 'ongoing.project.name.post.graduate.islamic.dawah',
	// 		img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/dawah_post_grad_diploma.jpg',
	// 		description: 'ongoing.project.description.post.graduate.islamic.dawah'
	// 	},
	// 	{
	// 		id: 2,
	// 		name: 'ongoing.project.name.quran',
	// 		img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/ongoing-project-quran-year.jpg',
	// 		description: 'ongoing.project.description.quran'
	// 	},
	// 	{
	// 		id: 3,
	// 		name: 'ongoing.project.name.self.reliance.project',
	// 		img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/ongoing-project-self-reliant-2024.jpg',
	// 		description: 'ongoing.project.description.self.reliance.project'
	// 	},
	// 	{
	// 		id: 4,
	// 		name: 'ongoing.project.name.smart.tailoring',
	// 		img: 'https://cdn.assunnahfoundation.org/home/assunnah-project-smart-tailoring-fashion-design.jpeg',
	// 		description: 'ongoing.project.desc.smart.tailoring'
	// 	},
	// 	{
	// 		id: 5,
	// 		name: 'ongoing.project.name.web.development',
	// 		img: 'https://cdn.assunnahfoundation.org/home/assunnah-project-3.jpg',
	// 		description: 'ongoing.project.desc.web.development'
	// 	},
	// 	{
	// 		id: 6,
	// 		name: 'ongoing.project.name.small.business',
	// 		img: 'https://cdn.assunnahfoundation.org/home/small-business-management.jpg',
	// 		description: 'ongoing.project.desc.small.business'
	// 	}
	// ]

	const OngoingProjects = [
		// {
		// 	id: 1,
		// 	name: 'ongoing.project.name.emergency.relief.distribution',
		// 	img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/emergency-relief-distribution-2024.jpg',
		// 	description: 'ongoing.project.desc.emergency.relief.distribution'
		// },
		// {
		// 	id: 2,
		// 	name: 'ongoing.project.name.anti.discrimination.movement',
		// 	img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/financial-support-anti-discrimination-movement-2024.jpg',
		// 	description: 'ongoing.project.desc.anti.discrimination.movement'
		// },
		// {
		// 	id: 3,
		// 	name: 'ongoing.project.name.tree.plantation',
		// 	img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/tree-plantation-project-2024.jpg',
		// 	description: 'ongoing.project.description.tree.plantation'
		// },
		// {
		// 	id: 1,
		// 	name: 'ongoing.project.name.iftar',
		// 	img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/iftar-distribution-2025.jpg',
		// 	description: 'ongoing.project.desc.iftar'
		// },
		{
			id: 1,
			name: 'ongoing.project.name.post.graduate.islamic.dawah',
			img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/dawah_post_grad_diploma.jpg',
			description: 'ongoing.project.description.post.graduate.islamic.dawah'
		},
		// {
		// 	id: 2,
		// 	name: 'ongoing.project.name.quran',
		// 	img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/ongoing-project-quran-year.jpg',
		// 	description: 'ongoing.project.description.quran'
		// },
		// {
		// 	id: 6,
		// 	name: 'ongoing.project.name.self.reliance.project',
		// 	img: 'https://cdn.assunnahfoundation.org/home/ongoing-project/ongoing-project-self-reliant-2024.jpg',
		// 	description: 'ongoing.project.description.self.reliance.project'
		// },
		{
			id: 2,
			name: 'ongoing.project.name.smart.tailoring',
			img: 'https://cdn.assunnahfoundation.org/home/assunnah-project-smart-tailoring-fashion-design.jpeg',
			description: 'ongoing.project.desc.smart.tailoring'
		},
		// {
		// 	id: 4,
		// 	name: 'ongoing.project.name.web.development',
		// 	img: 'https://cdn.assunnahfoundation.org/home/assunnah-project-3.jpg',
		// 	description: 'ongoing.project.desc.web.development'
		// },
		{
			id: 3,
			name: 'ongoing.project.name.small.business',
			img: 'https://cdn.assunnahfoundation.org/home/small-business-management.jpg',
			description: 'ongoing.project.desc.small.business'
		}
	]

	return (
		<div>
			<LoadingBar height={3} color='#0C8F4D' ref={loadingRef} />
			<Auxiliary>
				{/* Quick Donation */}
				<QuickDonation
					productList={productList}
					gatewayList={gateways}
					idRequired={idRequired}
					amountDisabled={amountDisabled}
				/>

				{/* Carousel */}
				<Row className='gx-main-content-wrapper'>
					{
						<Col
							xl={24}
							lg={24}
							md={24}
							sm={24}
							xs={24}
							style={{ padding: '0px' }}
						>
							<Carousel autoplay className='gx-user-fnd'>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/slider-foundation-complex.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/tree-plantation-2023.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/skill-slider.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/slide-00001.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/slide-00002.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/slide-00003.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/slide-00004.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/slide-00005.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/slide-00006.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
								<div className='carousel-overlay-container'>
									<img
										alt='orphan'
										src='https://cdn.assunnahfoundation.org/home/slide-00007.jpg'
										witdh='100%'
										className='gx-rounded-lg'
									/>
								</div>
							</Carousel>
						</Col>
					}
				</Row>

				{/* History */}
				<div
					style={{ background: '#fff', width: '100%', paddingBottom: '30px' }}
				>
					<Row className='gx-main-content-wrapper'>
						<Col
							xl={10}
							lg={10}
							md={10}
							sm={24}
							xs={24}
							style={{
								marginTop: '10px',
								marginBottom: '10px'
							}}
						>
							<div>
								<img
									style={{
										borderRadius: '50%',
										paddingLeft: '20px',
										paddingRight: '20px',
										width: '100%'
									}}
									alt='orphan'
									src='https://cdn.assunnahfoundation.org/home/golden-gate.jpg'
								/>
							</div>
						</Col>
						<Col
							xl={14}
							lg={14}
							md={14}
							sm={24}
							xs={24}
							style={{
								marginTop: '10px',
								marginBottom: '10px'
							}}
							className='vertical-center'
						>
							<div>
								<h1 style={{ color: '#008E48' }}>
									<IntlMessages id='home.shortAbout.title' />
								</h1>
								<hr style={{ borderTop: '3px solid #bbb' }} />
								<p>
									<IntlMessages id='home.shortAbout.desc' />
								</p>
								<Timeline
									style={{
										marginTop: '40px'
									}}
								>
									<Timeline.Item color='green'>
										<Link to={'/about/education'}>
											<IntlMessages id='home.shortAbout.item1' />
										</Link>
									</Timeline.Item>
									<Timeline.Item color='green'>
										<Link to={'/about/charity'}>
											<IntlMessages id='home.shortAbout.item2' />
										</Link>
									</Timeline.Item>
									<Timeline.Item color='green'>
										<Link to={'/about/dawah'}>
											<IntlMessages id='home.shortAbout.item3' />
										</Link>
									</Timeline.Item>
								</Timeline>
							</div>
						</Col>
					</Row>
				</div>

				{/* donation packages */}
				<div style={{ width: '100%' }}>
					<div>
						<h1
							style={{
								textAlign: 'center',
								paddingTop: '30px',
								paddingLeft: '15px',
								paddingRight: '15px'
							}}
						>
							{intl.formatMessage({ id: 'donation.banner' })}
						</h1>
					</div>
					<div class={'gx-main-content-wrapper'}>
						<Row>
							{carouselProducts
								.sort((a, b) => parseInt(a.priority) - parseInt(b.priority))
								.slice(0, 6)
								.map((product, pIndex) => {
									return (
										// <Col xl={8} lg={8} md={12} sm={24} xs={24} key={pIndex}>
										// 	<Card
										// 		size='small'
										// 		hoverable
										// 		cover={
										// 			<img
										// 				alt='Donate'
										// 				src={product.primaryBanner}
										// 				style={{ height: '18.75rem' }}
										// 			/>
										// 		}
										// 		onClick={() => {
										// 			history.push('/donate' + product.routeExtension)
										// 		}}
										// 		style={{ height: '35.875rem' }}
										// 	>
										// 		<div
										// 			style={{
										// 				display: 'flex',
										// 				flexDirection: 'column',
										// 				justifyContent: 'space-between',
										// 				height: '16rem',
										// 				paddingLeft: '0.5rem',
										// 				paddingRight: '0.5rem'
										// 			}}
										// 		>
										// 			<div>
										// 				<h1
										// 					style={{
										// 						textAlign: 'center',
										// 						color: 'green',
										// 						fontSize: '1.625rem',
										// 						marginTop: '0.87rem'
										// 					}}
										// 				>
										// 					<IntlMessages id={product.name} />
										// 				</h1>
										// 				<h4
										// 					style={{
										// 						fontSize: '1rem',
										// 						fontStyle: 'normal',
										// 						fontWeight: '400',
										// 						lineHeight: 'normal',
										// 						textAlign: 'center',
										// 						paddingBottom: 19,
										// 						overflow: 'hidden',
										// 						textOverflow: 'ellipsis',
										// 						display: '-webkit-box',
										// 						WebkitLineClamp: 4,
										// 						lineClamp: 5,
										// 						maxHeight: '6.5rem',
										// 						WebkitBoxOrient: 'vertical'
										// 					}}
										// 				>
										// 					<IntlMessages id={product.description} />
										// 				</h4>
										// 			</div>
										// 			<div style={{ justifyContent: 'center' }}>
										// 				<Button
										// 					type='primary'
										// 					style={{
										// 						backgroundColor: '#EE0000',
										// 						color: '#ffffff',
										// 						width: '100%'
										// 					}}
										// 					size='large'
										// 				>
										// 					<Link
										// 						style={{ color: '#ffffff' }}
										// 						to={'/donate' + product.routeExtension}
										// 					>
										// 						<IntlMessages id='payment.info.donateButton' />
										// 					</Link>
										// 				</Button>
										// 			</div>
										// 		</div>
										// 	</Card>
										// </Col>
										<Col xl={8} lg={8} md={12} sm={24} xs={24} key={pIndex}>
											<Card
												size='small'
												hoverable
												cover={
													<img
														alt='Donate'
														src={product.primaryBanner}
														// style={{ height: '18.75rem' }}
													/>
												}
												onClick={() => {
													history.push('/donation' + product.routeExtension)
												}}
												// style={{ height: '35.875rem' }}
											>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														justifyContent: 'space-between',
														height: '16rem',
														paddingLeft: '0.5rem',
														paddingRight: '0.5rem'
													}}
												>
													<div>
														<h1
															style={{
																textAlign: 'center',
																color: 'green',
																fontSize: '1.625rem',
																marginTop: '0.87rem'
															}}
														>
															<IntlMessages id={product.name} />
														</h1>
														<h4
															style={{
																fontSize: '1rem',
																fontStyle: 'normal',
																fontWeight: '400',
																lineHeight: 'normal',
																textAlign: 'center',
																overflow: 'hidden',
																textOverflow: 'ellipsis',
																display: '-webkit-box',
																WebkitLineClamp: 5,
																lineClamp: 5,
																WebkitBoxOrient: 'vertical'
															}}
														>
															<IntlMessages id={product.description} />
														</h4>
													</div>
													<div style={{ justifyContent: 'center' }}>
														<Button
															type='primary'
															style={{
																backgroundColor: '#EE0000',
																color: '#ffffff',
																width: '100%'
															}}
															size='large'
														>
															<Link
																style={{ color: '#ffffff' }}
																to={'/donation' + product.routeExtension}
															>
																<IntlMessages id='payment.info.donateButton' />
															</Link>
														</Button>
													</div>
												</div>
											</Card>
										</Col>
									)
								})}
						</Row>
						<Button
							type='primary'
							style={{
								backgroundColor: '#EE0000',
								color: '#ffffff',
								width: '25%',
								left: '38%',
								marginBottom: '35px'
							}}
							size='large'
							onClick={() => history.push('/donate')}
						>
							<IntlMessages id='home.button.more' />
						</Button>
					</div>
				</div>

				{/* Ongoing projects */}
				<div style={{ width: '100%', backgroundColor: '#fff' }}>
					<div>
						<h1
							style={{
								textAlign: 'center',
								paddingTop: '30px',
								paddingLeft: '15px',
								paddingRight: '15px'
							}}
						>
							{intl.formatMessage({ id: 'ongoing.projects.banner' })}
						</h1>
					</div>
					<div class={'gx-main-content-wrapper'}>
						<Row justify='space-evenly'>
							{OngoingProjects.map((project, pIndex) => {
								return (
									<Col xl={8} lg={8} md={12} sm={24} xs={24} key={pIndex}>
										<Card
											size='small'
											hoverable
											cover={<img alt='project' src={project.img} />}
											onClick={() => {
												history.push(`/ongoing-projects/${project.id}`)
											}}
										>
											<div className='' style={{ height: '13rem' }}>
												<h1
													style={{
														textAlign: 'center',
														color: 'green',
														fontSize: '1.525rem',
														marginTop: '0.87rem',
														cursor: 'pointer'
													}}
												>
													<IntlMessages id={project.name} />
												</h1>
												<h4
													style={{
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														display: '-webkit-box',
														WebkitLineClamp: 5,
														WebkitBoxOrient: 'vertical',
														textAlign: 'center',
														marginTop: '0.87rem',
														cursor: 'pointer',
														padding: '0px 10px'
													}}
												>
													<IntlMessages id={project.description} />
												</h4>
												{/* <div style={{ justifyContent: 'center' }}>
												<Button
													type='primary'
													style={{
														backgroundColor: '#EE0000',
														color: '#ffffff',
														width: '100%'
													}}
													size='large'
												>
													<Link
														style={{ color: '#ffffff' }}
														to={'/donate' + product.routeExtension}
													>
														<IntlMessages id='payment.info.donateButton' />
													</Link>
												</Button>
											</div> */}
											</div>
										</Card>
									</Col>
								)
							})}
						</Row>
					</div>
				</div>

				{/* news section */}
				<div style={{ width: '100%' }}>
					<div>
						<h1
							style={{
								textAlign: 'center',
								paddingTop: '30px',
								paddingLeft: '15px',
								paddingRight: '15px'
							}}
						>
							{intl.formatMessage({ id: 'home.news.title' })}
						</h1>
					</div>
					<div class={'gx-main-content-wrapper'}>
						<Row>
							{currentNews.slice(0, 3).map((news, index) => {
								return (
									<Col xl={8} lg={8} md={12} sm={24} xs={24} key={index}>
										<Card
											size='small'
											hoverable
											style={{ width: '100%' }}
											onClick={() => {
												//history.push('/news-details/' + news._id)
												history.push('/news-details/' + news.routeExtension)
											}}
										>
											{/* <h1 style={{ textAlign: 'left' }}>
												{language.name === 'English'
													? news.title.en
													: language.name === 'Bengali'
													? news.title.bn
													: null}
											</h1> */}
											<div>
												<img
													style={{
														// width: '100%',
														height: 254,
														width: 408,
														marginBottom: 5,
														borderRadius: '5px'
													}}
													src={news.titleImage}
													alt='Italian Trulli'
												/>
											</div>
											<h6>
												{language.name === 'English'
													? new Date(news.created.dateTime).toLocaleString()
													: language.name === 'Bengali'
													? new Date(news.created.dateTime).toLocaleString(
															'bn-BD'
													  )
													: null}
											</h6>
											<h3
												style={{
													textAlign: 'left',
													paddingBottom: 0,
													height: '30px'
													// overflowY: 'scroll'
												}}
											>
												{language.name === 'English'
													? news.title.en
													: language.name === 'Bengali'
													? news.title.bn
													: null}
											</h3>
										</Card>
									</Col>
								)
							})}
						</Row>
						<Button
							type='primary'
							style={{
								backgroundColor: '#EE0000',
								color: '#ffffff',
								width: '25%',
								left: '38%',
								marginBottom: '35px'
							}}
							size='large'
							onClick={() => history.push('/news')}
						>
							<IntlMessages id='home.button.more' />
						</Button>
					</div>
				</div>

				{/* 3 Cards */}
				<div style={{ width: '100%', backgroundColor: '#fff' }}>
					<div>
						<h1
							style={{
								textAlign: 'center',
								paddingTop: '30px',
								paddingLeft: '15px',
								paddingRight: '15px'
							}}
						>
							{intl.formatMessage({ id: 'nav.projects' })}
						</h1>
					</div>
					<div className='gx-main-content-wrapper'>
						<Row>
							<Col
								xl={8}
								lg={8}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<div
									className='overlay-container gx-rounded-lg'
									style={{
										backgroundImage: 'linear-gradient(45deg, #339966, #009999)'
									}}
									onClick={() => {
										history.push('/projects/self-relience')
									}}
								>
									<div className='overlay gx-rounded-lg'></div>
									<div className='overlay-content'>
										<center>
											<h1
												style={{ zIndex: '5', color: '#ffffff' }}
												className='vertical-center'
											>
												{intl.formatMessage({
													id: 'nav.projects.menu.1.title'
												})}
											</h1>
											<p style={{ zIndex: '5', color: '#ffffff' }}>
												<IntlMessages id='nav.projects.menu.1.desc' />
											</p>
											<Button type='primary' size='large'>
												<Link
													style={{ color: '#ffffff' }}
													to={'/projects/self-relience'}
												>
													<IntlMessages id='home.events.button' />
												</Link>
											</Button>
										</center>
									</div>
								</div>
							</Col>
							<Col
								xl={8}
								lg={8}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<div
									className='overlay-container gx-rounded-lg'
									style={{
										backgroundImage: 'linear-gradient(45deg, #0099cc, #009999)'
									}}
									onClick={() => {
										history.push(
											'/projects/iftar-and-ramadan-food-distribution'
										)
									}}
								>
									<div className='overlay gx-rounded-lg'></div>
									<div className='overlay-content'>
										<center>
											<h1
												style={{ zIndex: '5', color: '#ffffff' }}
												className='vertical-center'
											>
												{intl.formatMessage({
													id: 'nav.projects.menu.8.title'
												})}
											</h1>
											<p style={{ zIndex: '5', color: '#ffffff' }}>
												<IntlMessages id='nav.projects.menu.8.desc' />
											</p>
											<Button type='primary' size='large'>
												<Link
													style={{ color: '#ffffff' }}
													to={'/projects/iftar-and-ramadan-food-distribution'}
												>
													<IntlMessages id='home.joinUs.button' />
												</Link>
											</Button>
										</center>
									</div>
								</div>
							</Col>
							<Col
								xl={8}
								lg={8}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<div
									className='overlay-container gx-rounded-lg'
									style={{
										backgroundImage: 'linear-gradient(45deg, #0099cc, #009999)',
										marginLeft: '-1 6px'
									}}
									onClick={() => {
										history.push('/projects/tree-plantation-project')
									}}
								>
									<div className='overlay gx-rounded-lg'></div>
									<div className='overlay-content'>
										<center>
											<h1
												style={{ zIndex: '5', color: '#ffffff' }}
												className='vertical-center'
											>
												{intl.formatMessage({
													id: 'nav.projects.menu.7.title'
												})}
											</h1>
											<p style={{ zIndex: '5', color: '#ffffff' }}>
												<IntlMessages id='nav.projects.menu.7.desc' />
											</p>
											<Button type='primary' size='large'>
												<Link
													style={{ color: '#ffffff' }}
													to={'/projects/tree-plantation-project'}
												>
													<IntlMessages id='home.joinUs.button' />
												</Link>
											</Button>
										</center>
									</div>
								</div>
							</Col>
						</Row>
						<Button
							type='primary'
							style={{
								backgroundColor: '#EE0000',
								color: '#ffffff',
								width: '25%',
								left: '38%',
								marginBottom: '35px'
							}}
							size='large'
							onClick={() => history.push('/projects/self-relience')}
						>
							<IntlMessages id='home.button.more' />
						</Button>
					</div>
				</div>

				{/* videos */}
				<div style={{ width: '100%' }}>
					<div>
						<h1
							style={{
								textAlign: 'center',
								paddingTop: '30px',
								paddingLeft: '15px',
								paddingRight: '15px'
							}}
						>
							<IntlMessages id='home.videos.title' />
						</h1>
					</div>
					<div class={'gx-main-content-wrapper'}>
						<Row>
							{videoData.slice(0, 3).map((item, index) => {
								return (
									<Col
										xl={8}
										lg={8}
										md={12}
										sm={24}
										xs={24}
										style={{ paddingBottom: '26px' }}
									>
										<div className='youtube-container'>
											{/* <img alt='zakat' src={product.primaryBanner} /> */}
											<iframe
												className='youtube-frame'
												type='text/html'
												title={
													<IntlMessages
														id={'nav.videos.nav.videos.title.' + index++}
													/>
												}
												src={
													'https://www.youtube.com/embed/' +
													item +
													'?modestbranding=1'
												}
												frameBorder='0'
												allowFullScreen
											></iframe>
										</div>
										<h4 style={{ marginTop: '10px', textAlign: 'center' }}>
											<IntlMessages id={'nav.videos.title.' + index++} />
										</h4>
									</Col>
								)
							})}
						</Row>
						<Button
							type='primary'
							style={{
								backgroundColor: '#EE0000',
								color: '#ffffff',
								width: '25%',
								left: '38%',
								marginBottom: '35px'
							}}
							size='large'
							onClick={() => history.push('/videos')}
						>
							<IntlMessages id='home.button.more' />
						</Button>
					</div>
				</div>

				{/* gallery */}
				<div style={{ width: '100%', backgroundColor: '#fff' }}>
					<div>
						<h1
							style={{
								textAlign: 'center',
								paddingTop: '30px',
								paddingLeft: '15px',
								paddingRight: '15px'
							}}
						>
							<IntlMessages id='nav.gallery' />
						</h1>
					</div>
					<div class={'gx-main-content-wrapper'}>
						<Row>
							<Col
								xl={6}
								lg={6}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<Image
									style={{ borderRadius: '5px' }}
									src='https://cdn.assunnahfoundation.org/gallery/iftar_gallery_4.jpg'
								/>
							</Col>
							<Col
								xl={6}
								lg={6}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<Image
									style={{ borderRadius: '5px' }}
									src='https://cdn.assunnahfoundation.org/gallery/qurbani_gallery_3.jpg'
								/>
							</Col>
							<Col
								xl={6}
								lg={6}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<Image
									style={{ borderRadius: '5px' }}
									src='https://cdn.assunnahfoundation.org/gallery/winter_clothing_gallery_5.jpg'
								/>
							</Col>
							<Col
								xl={6}
								lg={6}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<Image
									style={{ borderRadius: '5px' }}
									src='https://cdn.assunnahfoundation.org/gallery/van_distribution_gallery_4.jpg'
								/>
							</Col>
							<Col
								xl={6}
								lg={6}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<Image
									style={{ borderRadius: '5px' }}
									src='https://cdn.assunnahfoundation.org/gallery/relief_distribution_gallery_8.jpg'
								/>
							</Col>
							<Col
								xl={6}
								lg={6}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<Image
									style={{ borderRadius: '5px' }}
									src='https://cdn.assunnahfoundation.org/gallery/tube_well_distribution_gallery_6.jpg'
								/>
							</Col>
							<Col
								xl={6}
								lg={6}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<Image
									style={{ borderRadius: '5px' }}
									src='https://cdn.assunnahfoundation.org/gallery/food_distribution_gallery_5.jpg'
								/>
							</Col>
							<Col
								xl={6}
								lg={6}
								md={12}
								sm={24}
								xs={24}
								style={{ paddingBottom: '26px' }}
							>
								<Image
									style={{ borderRadius: '5px' }}
									src='https://cdn.assunnahfoundation.org/gallery/orphan_gallery_2.jpg'
								/>
							</Col>
						</Row>
						<Button
							type='primary'
							style={{
								backgroundColor: '#EE0000',
								color: '#ffffff',
								width: '25%',
								left: '38%',
								marginBottom: '35px'
							}}
							size='large'
							onClick={() => history.push('/gallery')}
						>
							<IntlMessages id='home.button.more' />
						</Button>
					</div>
				</div>

				{/* <div style={{ width: '100%' }}>
					<div class={'gx-main-content-wrapper'}>
						<Row>
							<Col
								xl={12}
								lg={12}
								md={24}
								sm={24}
								xs={24}
								style={{ paddingRight: 0 }}
							>
								<img
									alt='Special Edition Party Spas'
									style={{ marginBottom: '10px' }}
									src='https://cdn.assunnahfoundation.org/gallery/relief_distribution_gallery_8.jpg'
								/>
							</Col>
							<Col xl={12} lg={12} md={24} sm={24} xs={24}>
								<Button
									type='primary'
									style={{
										backgroundColor: '#EE0000',
										color: '#ffffff',
										top: '40%',
										left: '5%',
										width: '90%',
										right: '5%'
									}}
									onClick={() => history.push('/volunteer')}
								>
									<IntlMessages id='nav.volunteer' />
								</Button>
							</Col>
						</Row>
					</div>
				</div> */}
				{/* <div style={{ padding: '20px' }}></div> */}

				{/* News */}
				{/* <div style={{ background: '#fff', width: '100%' }}>
					<Row className='gx-main-content-wrapper'>
						<div>
							<h1 style={{ textAlign: 'center', paddingBottom: '20px' }}>{intl.formatMessage({ id: 'home.news.title' })}</h1>
							<Col xl={24} lg={24} md={24} sm={24} xs={24} style={{ padding: '0px' }}>
								<Row>
									<Col xl={6} lg={6} md={24} sm={24} xs={24}>
										<Card
											style={{ textAlign: 'center' }}
											hoverable >
											<div className='news-overlay-container'>
												<img alt='zakat' src={'https://cdn.assunnahfoundation.org/donation/zakat.jpg'} />
												<div className='news-overlay'></div>
											</div>
											<div>
												<h4 style={{ color: 'green' }}>The Benefits of Giving to Charity</h4>
												<h5>The notion of giving charity to others...</h5>
												<h6>January 4th, 2021</h6>
											</div>
										</Card>
									</Col>
									<Col xl={6} lg={6} md={24} sm={24} xs={24}>
										<Card
											style={{ textAlign: 'center' }}
											hoverable >
											<div className='news-overlay-container'>
												<img alt='general' src={'https://scontent.fdac99-1.fna.fbcdn.net/v/t1.0-9/119211668_755468481687132_4438802757091503553_o.jpg?_nc_cat=105&ccb=2&_nc_sid=730e14&_nc_eui2=AeGcFGniHbQbhHv3PeV71ZUBj9NrC-ch7mmP02sL5yHuab9rn-3u1Eh82ivZEvi2aqY&_nc_ohc=CGrW4jgMk-YAX82Mg-w&_nc_ht=scontent.fdac99-1.fna&oh=dc2a5f8da5da5a768c0d66e77735b08a&oe=603093FE'} />
												<div className='news-overlay'></div>
											</div>
											<div>
												<h4 style={{ color: 'green' }}>The Benefits of Giving to Charity</h4>
												<h5>The notion of giving charity to others...</h5>
												<h6>January 4th, 2021</h6>
											</div>
										</Card>
									</Col>
									<Col xl={6} lg={6} md={24} sm={24} xs={24}>
										<Card
											style={{ textAlign: 'center' }}
											hoverable >
											<div className='news-overlay-container'>
												<img alt='orphan' src={'https://cdn.assunnahfoundation.org/donation/orphan.jpg'} />
												<div className='news-overlay'></div>
											</div>
											<div>
												<h4 style={{ color: 'green' }}>The Benefits of Giving to Charity</h4>
												<h5>The notion of giving charity to others...</h5>
												<h6>January 4th, 2021</h6>
											</div>
										</Card>
									</Col>
									<Col xl={6} lg={6} md={24} sm={24} xs={24}>
										<Card
											style={{ textAlign: 'center' }}
											hoverable >
											<div className='news-overlay-container'>
												<img alt='sadaqah' src={'https://cdn.assunnahfoundation.org/donation/sadaqah.jpg'} />
												<div className='news-overlay'></div>
											</div>
											<div>
												<h4 style={{ color: 'green' }}>The Benefits of Giving to Charity</h4>
												<h5>The notion of giving charity to others...</h5>
												<h6>January 4th, 2021</h6>
											</div>
										</Card>
									</Col>
								</Row>
							</Col>
						</div>
					</Row>
				</div> */}
			</Auxiliary>
		</div>
	)
}

export default injectIntl(Home)
